import { takeLatest } from 'redux-saga/effects';
import { getAccountPath } from '../../utils/firebase';

import { fetchExceptionsRoutine, resolveExceptionRoutine } from '../routines';
import { fetchSaga, saveSaga } from './helper';
import { post } from '../../utils/request';

function* watchFetchExceptionsSaga() {
  yield takeLatest(fetchExceptionsRoutine.TRIGGER,
    fetchSaga(fetchExceptionsRoutine, (payload) => getAccountPath('jobs', payload.jobId) + '/exceptions'));
}

function* watchResolveExceptionSaga() {
  yield takeLatest(resolveExceptionRoutine.TRIGGER,
    saveSaga(
      resolveExceptionRoutine,
      (payload) => {
        if (payload.values) {
          return getAccountPath('jobs', payload.values.get('jobId')) + '/exceptions/' + payload.values.getIn(['exception', 'id']) + '/resolve';
        } else {
          return getAccountPath('jobs', payload.jobId) + '/exceptions/' + payload.exception.id + '/resolve';
        }

      },
      () => post,
      (payload) => ({ notes: payload.values ? payload.values.get('notes') : payload.notes }),
    ));
}

export {
  watchFetchExceptionsSaga,
  watchResolveExceptionSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/exceptions.js